import React, { useState } from 'react';

// This type helps us to prevent duplicating AlertType in the whole file
// This type is for React.createContext and it is a main structuer for local useState
type StateStructuerType = {
  menu: string;
  setMenuState(menu: string): void;
};

// This is our Alert state schema
const stateStructuer: StateStructuerType = {
  menu: '',
  setMenuState: (menu: string) => {},
};

export const MenuState = React.createContext(stateStructuer);

const MenuStateProvider: React.FC<any> = ({ children }) => {
  // This is the local state and action function to bind the state concerned, it is same like stateStructuer schema but without setter functions
  const [menu, setMenu] = useState<any>('');

  /**
   * It sets the state of the alert. Set a new alert into AlertState context.
   * @param {boolean} status - boolean - This is the status of the alert. If it's true, the alert will
   * be shown. If it's false, the alert will be hidden.
   * @param {string} alertMessage - The message you want to display in the alert.
   * @param {AlertType} alertType - AlertType - This is an enum that I created to define the type of
   * alert.
   */
  const setMenuState = (menu: string) => {
    setMenu(menu);
  };

  // Creating a ready template to apply Context Provider. Because it is used in the entire system, it is called in the _app file.
  return (
    <MenuState.Provider value={{ menu, setMenuState }}>
      {children}
    </MenuState.Provider>
  );
};

export default MenuStateProvider;
